import { EnvironmentProviders } from '@angular/core';

import { provideModuleInfo } from '@mp/shared/util';
import { ClinicSuppliersPermissions } from '@mp/supplier-management/clinic-suppliers/feature';
import { PlatformSuppliersPermissions } from '@mp/supplier-management/platform-suppliers/feature';
import { provideModulePermissions } from '@mpk/shared/data-access';

const moduleName = 'SupplierManagement';

export function provideSupplierManagementFeature(): EnvironmentProviders[] {
  return [
    provideModuleInfo(moduleName, {
      displayName: 'Lieferantenmanagement',
    }),
    provideModulePermissions(moduleName, ClinicSuppliersPermissions, PlatformSuppliersPermissions),
  ];
}
